import styled from "styled-components";
import { UIStyleConstants } from "../../rule-engine-core/Common/UIStyleConstants";

export const EmptyContainer = styled("div")<{
    colGap?: number;
}>`
    top: ${(props) => props.colGap || 0}px;
    right: ${(props) => props.colGap || 0}px;
    left: ${(props) => props.colGap || 0}px;
    bottom: ${(props) => props.colGap || 0}px;
    color: ${UIStyleConstants.TEXT_COLOR_DEFAULT};
    display: flex;
    align-items: center;
    justify-content: center;
    border: 1px dashed ${UIStyleConstants.GRAY_COLOR};
    border-radius: 5px;
    font-size: 16px;

    position: absolute;
    flex-wrap: wrap;
    padding: 2px 20px;
    min-height: 75px;
`;

export const ControlDiv = styled.div`
    background: ${UIStyleConstants.GRAY_LIGHT_COLOR};
    height: 40px;
    border: 1px dashed ${UIStyleConstants.GRAY_COLOR};
    width: 238px;
    font-size: 14px;

    margin: 10px 20px;
    display: flex;
    align-items: center;
    padding: 0 17px;
    border-radius: 5px;

    img {
        margin-left: 30px;
    }
`;
